import { Alert, Box } from '@mui/material';
import { useResolvedHmiTemplate } from '../useResolvedHmiTemplate';
import HMIRenderer from './HMIRenderer';

export interface HMITabProps {
  twinId?: string;
  solutionId?: string;
  siteId?: string;
  canConfigure?: boolean;
  /** Switches the host page to its "HMI Configuration" tab (a sibling of this "HMI" tab). */
  onConfigure?: () => void;
}

/**
 * Entry point mounted as the top-level "HMI" tab in the Asset Hierarchy
 * (a sibling of Properties / Digital Twin / Asset Configurations / ...).
 * Fetches the server-driven template configured for this twin from the HMI
 * Configuration service and renders it.
 */
function HMITab({ twinId, solutionId, siteId, canConfigure, onConfigure }: HMITabProps) {
  const { template, loading } = useResolvedHmiTemplate(solutionId, siteId, twinId);

  if (loading) {
    // The host page (`SolutionAssetHierarchy`) already shows a single
    // top-level loader while this twin's data is loading - avoid a second,
    // overlapping spinner here (matches the "Asset Configurations" tab).
    return null;
  }

  if (!template) {
    return (
      <Alert severity="info">
        No HMI template is configured yet. Go to the &quot;HMI
        Configuration&quot; tab to create one for this asset.
      </Alert>
    );
  }

  return (
    <Box>
      <HMIRenderer
        template={template}
        twinId={twinId}
        onConfigure={onConfigure}
        canConfigure={canConfigure}
      />
    </Box>
  );
}

export default HMITab;
